var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.117 3.30006V3.3C0.117 1.54238 1.58305 0.1 3.4 0.1H30.6C32.4176 0.1 33.9 1.54302 33.9 3.3V23.1C33.9 24.857 32.4176 26.3 30.6 26.3H6.8H6.75945L6.73035 26.3282L0.100135 32.7635L0.117 3.30006ZM30.6 23.2H30.7V23.1V3.3V3.2H30.6H3.4H3.3V3.3V25.0305V25.2669L3.46965 25.1023L4.45565 24.1453L5.42955 23.2H30.6ZM15.4 16.6H18.6V19.7H15.4V16.6ZM15.4 6.7H18.6V13.1H15.4V6.7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSupport);
export default __webpack_public_path__ + "static/media/feedback-support.8de0b24ca0e5b9a09999a23d7417f88b.svg";
export { ForwardRef as ReactComponent };